import React from 'react'
import './content.scss'

export default function EmeraldWhoWeServeSection() {
  const whoWeServeBoxData = [
    { link: '/physician-office-supplies', title: 'Physician & Healthcare Providers' },
    { link: '/surgery-center-supplies', title: 'Surgical Facilities & Outpatient Facilities' },
    { link: '/dialysis-center-supplies', title: 'Dialysis & Renal Care' },
    { link: '/urgent-care-medical-supplies', title: 'Clinics, Treatment, & Urgent Care Centers' },
    { link: '/idn-hospital-supplies', title: 'Health Systems/IDNs' },
    { link: '/solutions/medical-supply-distribution', title: 'Specialty Providers' },
    { link: '/government-medical-supplies', title: 'Governments & Public Sector' },
    { link: '/ems-supplies', title: 'Emergency Medical Services' },
    { link: '/retail-dealmed-medical-products', title: 'Omnichannel & Retail' },
  ]

  const WhoWeServeDataBox = ({ data }) => {
    return (
      <a href={data.link} className="wws__box-link">
        <div className="wws__box">
          <p>{data.title}</p>
        </div>
      </a>
    )
  }

  return (
    <div className="wws">
      <div className="container">
        <div className="wws__titles">
          <h2 className="wws__title">Who we serve</h2>
          <p className="wws__subtitle">Whatever you run, run it well.</p>
        </div>
        <div className="wws__boxes">
          {whoWeServeBoxData.map((data, index) => (
            <WhoWeServeDataBox key={index} data={data} />
          ))}
        </div>
      </div>
    </div>
  )
}
